import React from 'react';
import cx from 'classnames';

import { Typography as AntTypography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';

import styles from './Typography.module.scss';

export interface ITypographyParagraphProps extends ParagraphProps {
  noMargin?: boolean;
}

export const TypographyParagraph: React.FC<ITypographyParagraphProps> = (
  props
) => {
  const { noMargin, className } = props;

  return (
    <AntTypography.Paragraph
      className={cx(styles.Paragraph, { 'no-margin': noMargin }, className)}
      {...props}
    />
  );
};
